<app-loader
	[enableCircle]="true"
	[isActive]="this.isLoadingAsync | async"
	[isAfterViewInit]="false"
></app-loader>
<h1 matDialogTitle>
	<div class="flex flex-row items-center justify-start">
		<div>{{ 'client.create' | translate }}</div>
		<div class="flex-auto"></div>
		<button
			mat-icon-button
			matDialogClose
			tabindex="-1"
		>
			<mat-icon>close</mat-icon>
		</button>
	</div>
</h1>
<mat-dialog-content cdkTrapFocus>
	<form
		(submit)="$event.preventDefault()"
		[formGroup]="this.csGroup"
	>
		<div class="flex flex-col items-stretch justify-start gap-2">
			<div class="flex flex-col gap-2 sm:flex-row sm:items-start">
				<mat-form-field
					appearance="fill"
					class="flex-auto"
				>
					<mat-label>Name</mat-label>
					<input
						cdkInitialFocus
						formControlName="name"
						matInput
						required
						type="text"
					>
					<mat-error *ngIf="this.csErrors as error">{{
						error.content | translate: error.args || {}
					}}</mat-error>
				</mat-form-field>

				<mat-form-field
					appearance="fill"
					class="project-color-field"
				>
					<mat-label>{{ 'client.color' | translate }}</mat-label>
					<input
						autocomplete="off"
						formControlName="colorText"
						matInput
						maxlength="7"
						spellcheck="false"
					>
					<mat-error
						*ngIf="csGroup.controls.colorText.touched && csGroup.controls.colorText.errors?.invalidHex"
					>
						{{ 'errors.invalidHex' | translate }}
					</mat-error>
					<div
						(colorPickerChange)="onColorPicked($event)"
						[colorPicker]="csGroup.value.color"
						[cpAlphaChannel]="'disabled'"
						[cpCmykEnabled]="false"
						[cpOutputFormat]="'hex'"
						[cpPosition]="'bottom'"
						[cpPositionOffset]="'24px'"
						[matTooltip]="'client.color' | translate"
						[style.backgroundColor]="csGroup.value.color"
						class="project-color-dot project-color-dot--suffix color-picker-material"
						matSuffix
					></div>
				</mat-form-field>
			</div>
			<mat-form-field>
				<mat-label>{{ 'Description' | translate }}</mat-label>
				<textarea
					formControlName="description"
					matInput
				></textarea>
			</mat-form-field>
		</div>
	</form>
</mat-dialog-content>
<mat-dialog-actions
	[matTooltip]="'workspace.errors.admin-create-client' | translate"
	[matTooltipDisabled]="this.workspace$createPermission | async"
	class="mat-action-filled"
>
	<button
		(click)="this.addEntry()"
		[disabled]="this.csGroup.invalid || !(this.workspace$createPermission | async)"
		class="mat-action-filled"
		color="primary"
		mat-flat-button
	>
		{{ 'client.create' | translate }}
	</button>
</mat-dialog-actions>
